
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.53 13.47a.75.75 0 00-1.06 1.06l1.06-1.06zM11 16l-.53.53a.75.75 0 001.06 0L11 16zm4.53-3.47a.75.75 0 10-1.06-1.06l1.06 1.06zM18.25 7v12h1.5V7h-1.5zM17 20.25H7v1.5h10v-1.5zM5.75 19V7h-1.5v12h1.5zM7 5.75h2v-1.5H7v1.5zm8 0h2v-1.5h-2v1.5zm-8 14.5c-.69 0-1.25-.56-1.25-1.25h-1.5A2.75 2.75 0 007 21.75v-1.5zM18.25 19c0 .69-.56 1.25-1.25 1.25v1.5A2.75 2.75 0 0019.75 19h-1.5zm1.5-12A2.75 2.75 0 0017 4.25v1.5c.69 0 1.25.56 1.25 1.25h1.5zm-14 0c0-.69.56-1.25 1.25-1.25v-1.5A2.75 2.75 0 004.25 7h1.5zm2.72 7.53l2 2 1.06-1.06-2-2-1.06 1.06zm3.06 2l4-4-1.06-1.06-4 4 1.06 1.06zM11 3.75h2v-1.5h-2v1.5zm2 2.5h-2v1.5h2v-1.5zm-2 0c-.69 0-1.25-.56-1.25-1.25h-1.5A2.75 2.75 0 0011 7.75v-1.5zM14.25 5c0 .69-.56 1.25-1.25 1.25v1.5A2.75 2.75 0 0015.75 5h-1.5zM13 3.75c.69 0 1.25.56 1.25 1.25h1.5A2.75 2.75 0 0013 2.25v1.5zm-2-1.5A2.75 2.75 0 008.25 5h1.5c0-.69.56-1.25 1.25-1.25v-1.5z"}})])
          )
        }
      }
    